import React from 'react';
import * as bootstrap from 'bootstrap';
import { UneditableTextInput } from '../../../../components/tools/BootstrapControls';
import { convertMeterCommissionStatus } from '../../../../helpers/converters';
import { addUserRoleUpdateNotifier, userRole } from '../../../../helpers/userHelpers';
import uiHelpers from '../../../../helpers/uiHelpers';
import serviceUrls from '../../../../constants/serviceUrls';
import * as apiCaller from '../../../../helpers/apiCaller'
export default class MeterCommissionHeading  extends React.Component {

    reAttemptMessageModel;
    constructor(props) {
        super(props);
        addUserRoleUpdateNotifier(this.userRolesUpdated);
        this.state = {
            confirmingNotifyingWAS:false,
            confirmingMarkAsResolvedWAS:false,
            confirmingMarkAsResolvedDasCreation:false,
            confirmingMarkAsResolveMeterDecommission:false,
            submitting:false,
            successfulText:null,
            failedText:null
        }

        
    }

    async componentDidMount() {
        this.reAttemptMessageModel = new bootstrap.Modal(document.getElementById('re-attempt-message-modal'));
    }

    userRolesUpdated =  () => {
        this.forceUpdate();
    }

    markAsResolveWAS = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminResolveWasCdoConfirmedFailure,{id:this.props.meterCommission.id})
        .then(()=>{
            this.setState({successfulText:"Your request has been completed.",failedText:null,  confirmingNotifyingWAS:false, confirmingMarkAsResolvedWAS:false, submitting:false})
            this.reAttemptMessageModel.show();
            this.props.refreshPage();
        }).catch(()=>{
            uiHelpers.hideProgressOnTop();
            this.setState({submitting:false, confirmingNotifyingWAS:false, confirmingMarkAsResolvedWAS:false})
        });
    }

    notifyWas = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminNotifyWasCdoConfirmed,{id:this.props.meterCommission.id})
        .then((data)=>{
            if(data.succeed) {
                this.setState({successfulText:"Your request has been completed, and you may now verify it in WAS.",failedText:null,  confirmingNotifyingWAS:false, confirmingMarkAsResolvedWAS:false, submitting:false})
            } else {
                this.setState({successfulText:null,failedText:'Failed to notify WAS that this form is "CDO confirmed" in the portal. Please check the Audit logs for more information.',confirmingNotifyingWAS:false, confirmingMarkAsResolved:false, submitting:false})
            }
            this.reAttemptMessageModel.show();
            this.props.refreshPage();
        }).catch(()=>{
            uiHelpers.hideProgressOnTop();
            this.setState({submitting:false, confirmingNotifyingWAS:false, confirmingMarkAsResolvedWAS:false})
        });
    }

    markAsResolveDASWorkspaceCreation = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminResolveDasWorkspaceCreation,{id:this.props.meterCommission.id})
        .then(()=>{
            this.setState({successfulText:"Your request has been completed.",failedText:null,  confirmingMarkAsResolvedDasCreation:false, submitting:false})
            this.reAttemptMessageModel.show();
            this.props.refreshPage();
        }).catch(()=>{
            uiHelpers.hideProgressOnTop();
            this.setState({submitting:false, confirmingMarkAsResolvedDasCreation:false})
        });
    }

    retriggerDASWorkspaceCreation = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminRetriggerDASWorkspaceCreation,{id:this.props.meterCommission.id})
        .then((data)=>{
            if(data.succeed) {
                this.setState({successfulText:"Your request has been completed, and you may now verify it in DAS.",failedText:null, submitting:false})
            } else {
                this.setState({successfulText:null,failedText:'Failed to create DAS workspace. Please check the Audit logs for more information.', submitting:false})
            }
            this.reAttemptMessageModel.show();
            this.props.refreshPage();
        }).catch(()=>{
            uiHelpers.hideProgressOnTop();
            this.setState({submitting:false, confirmingMarkAsResolvedDasCreation:false})
        });
    }

    markAsResolveMeterDecommission = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminResolveMeterDecommissionFailure,{id:this.props.meterCommission.id})
        .then(()=>{
            this.setState({successfulText:"Your request has been completed.",failedText:null,  confirmingMarkAsResolveMeterDecommission:false, submitting:false})
            this.reAttemptMessageModel.show();
            this.props.refreshPage();
        }).catch(()=>{
            uiHelpers.hideProgressOnTop();
            this.setState({submitting:false, confirmingMarkAsResolveMeterDecommission:false})
        });
    }

    retriggerMeterDecommission = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meterCommission.adminRetriggerMeterDecommission,{id:this.props.meterCommission.id})
        .then((data)=>{
            if(data.succeed) {
                this.setState({successfulText:"Your request has been completed, and you may now verify it in DAS.",failedText:null, submitting:false})
            } else {
                this.setState({successfulText:null,failedText:'Failed to create DAS workspace. Please check the Audit logs for more information.', submitting:false})
            }
            this.reAttemptMessageModel.show();
            this.props.refreshPage();
        }).catch(()=>{
            uiHelpers.hideProgressOnTop();
            this.setState({submitting:false, confirmingMarkAsResolveMeterDecommission:false})
        });
    }

    closeModel = () => {
        this.reAttemptMessageModel.hide();
    }

    render() {
        const meterCommission = this.props.meterCommission;
        return <>
            <h3 class="mb-1">
                Meter Compliance Process
            </h3>
            <p>
                {meterCommission.consent.governmentOwn===true && <i className='text-primary fs-80'>(Government-owned consent in use)</i>}
                {meterCommission.consent.governmentOwn===false && <i className='text-primary fs-80'>(Private-owned consent in use)</i>}
            </p>
            <div className='d-none'>Form Version: {meterCommission.formVersion}</div>
            <div className='row'>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Form ID</>}
                        value={<>
                            {meterCommission.id}
                        </>}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Form Status</>}
                        value={<>
                            {convertMeterCommissionStatus(meterCommission.status)}
                            {meterCommission.wasCDOConfirmFailed && (userRole.isCDO || userRole.isSuperAdmin) && <span className='text-danger fs-80'> (with issue)</span>}
                        </>}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label="DQP"
                        value={meterCommission.owner.firstname?<>{meterCommission.owner.firstname} {meterCommission.owner.lastname}</>:null}
                    />
                </div>
                {this.props.renderWorkStatus && <div className='col-md-3 mb-3'>{this.props.renderWorkStatus()}</div>}
            </div>
            {meterCommission.meter && <>
                <div className='row'>
                    <div className='col-md-3 mb-3'>
                        <UneditableTextInput
                            label={<>DAS workspace ID</>}
                            value={meterCommission.meter.meterSiteId}
                        />
                    </div>
                    {meterCommission.meter.meterId && <div className='col-md-3 mb-3'>
                        <UneditableTextInput
                            label={<>Source ID</>}
                            value={meterCommission.meter.meterId}
                        />
                    </div>}
                </div>
            </>}

            {meterCommission.wasCDOConfirmFailed && (userRole.isCDO || userRole.isSuperAdmin) && <div className='card border-danger mb-3'>
                <div id="was-confimration-issue" class="card-body">
                    <p><b className='text-danger'>
                        Meter update has failed in WAS due to a technical error or data mismatch. Please resolve the errors and click on 'Update meter in WAS' as shown below.
                    </b></p>
                    <p> 
                        For details about the previous error(s), please check the <b className='text-primary'>Audit</b>. You can try the <span className='text-decoration-underline'>below 2 options</span> to resolve this issue.
                        <br/>Please note that if you choose "<b className='text-primary'>Mark as resolved</b>", the system will consider the issue has been manually resolved in WAS, and no further action will be taken by the portal.
                    </p>
                    {!this.state.confirmingNotifyingWAS && !this.state.confirmingMarkAsResolvedWAS && <div className='text-center'>
                        <button className='btn btn-primary me-2' disabled={this.state.submitting} onClick={()=>{this.setState({confirmingNotifyingWAS:true})}}>Update meter in WAS</button>
                        <button className='btn btn-primary' disabled={this.state.submitting} onClick={()=>{this.setState({confirmingMarkAsResolvedWAS:true})}}>Mark as resolved</button>
                    </div>}
                    {this.state.confirmingNotifyingWAS && <div className='bg-primary bg-opacity-10 text-center p-3'>
                        <p class="text-primary"><b>Please confirm that you want the system to notify WAS again for CDO Confirmed of the meter.</b></p>
                        <div>
                            <button type="button" class="btn btn-secondary me-3" disabled={this.state.submitting} onClick={()=>{this.setState({confirmingNotifyingWAS:false})}}>Cancel</button>
                            <button type="button" class="btn btn-primary" disabled={this.state.submitting} onClick={this.notifyWas}>Confirm</button>
                        </div>
                    </div>}
                    {this.state.confirmingMarkAsResolvedWAS && <div className='bg-primary bg-opacity-10 text-center p-3'>
                        <p class="text-primary"><b>Please confirm that you want to mark this issue as resolved - without notifying WAS again.</b></p>
                        <div>
                            <button type="button" class="btn btn-secondary me-3" disabled={this.state.submitting} onClick={()=>{this.setState({confirmingMarkAsResolvedWAS:false})}}>Cancel</button>
                            <button type="button" class="btn btn-primary" disabled={this.state.submitting} onClick={this.markAsResolveWAS}>Confirm</button>
                        </div>
                    </div>}
                </div>
            </div>}

            {meterCommission.dasMeterCreationSucceeded===false && (userRole.isCDO || userRole.isSuperAdmin) && <div className='card border-danger mb-3'>
                <div class="card-body">
                    <p><b className='text-danger'>
                        DAS workspace creation failed
                    </b></p>
                    {meterCommission.dasMeterCreationAutoRetryCnt>=3 ? <>
                        {this.state.confirmingMarkAsResolvedDasCreation ? <> 
                            <p class="text-primary"><b>Please confirm that you want to mark this issue as resolved.. Please note that once you mark this as resolved, the DQP Portal won't have any function to create the DAS workspace again.</b></p>
                            <div>
                                <button type="button" class="btn btn-secondary me-3" disabled={this.state.submitting} onClick={()=>{this.setState({confirmingMarkAsResolvedDasCreation:false})}}>Cancel</button>
                                <button type="button" class="btn btn-primary" disabled={this.state.submitting} onClick={this.markAsResolveDASWorkspaceCreation}>Confirm</button>
                            </div>
                        </> : <>
                            <p> 
                                System has attempted to create the DAS workspace multiple times but continues to fail. Please contact the DAS team to resolve the issue first, and then re-trigger the process here.
                            </p>
                            <div className='text-center'>
                                <button type="button" className="btn btn-primary me-3" disabled={this.state.submitting} onClick={this.retriggerDASWorkspaceCreation}>Retrigger DAS workspace creation</button>
                                <button className='btn btn-primary' disabled={this.state.submitting} onClick={()=>{this.setState({confirmingMarkAsResolvedDasCreation:true})}}>Mark as resolved</button>
                            </div>
                        </>}
                        
                    </> : <div className='text-danger'>
                        System will re-attempt to do the DAS workspace creation soon. But if it fails for too many times, we need a CDO to manually trigger it here.
                    </div>}
                </div>
               
            </div>}

            {meterCommission.meterDecommissionSucceeded===false && (userRole.isCDO || userRole.isSuperAdmin) && <div className='card border-danger mb-3'>
                <div class="card-body">
                    <p><b className='text-danger'>
                        Meter decommission failed
                    </b></p>
                    {meterCommission.meterDecommissionAutoRetryCnt>=3 ? <>
                        {this.state.confirmingMarkAsResolveMeterDecommission ? <> 
                            <p class="text-primary"><b>Please confirm that you want to mark this issue as resolved.</b></p>
                            <div>
                                <button type="button" class="btn btn-secondary me-3" disabled={this.state.submitting} onClick={()=>{this.setState({confirmingMarkAsResolveMeterDecommission:false})}}>Cancel</button>
                                <button type="button" class="btn btn-primary" disabled={this.state.submitting} onClick={this.markAsResolveMeterDecommission}>Confirm</button>
                            </div>
                        </> : <>
                            <p> 
                                System has tried to decommission the replaced meter for a few times and still failing, please try to contact DAS team to fix the issue first and then re-trigger it here.
                            </p>
                            <div className='text-center'>
                                <button type="button" className="btn btn-primary me-3" disabled={this.state.submitting} onClick={this.retriggerMeterDecommission}>Retrigger meter decommission</button>
                                <button className='btn btn-primary' disabled={this.state.submitting} onClick={()=>{this.setState({confirmingMarkAsResolveMeterDecommission:true})}}>Mark as resolved</button>
                            </div>
                        </>}
                        
                    </> : <div className='text-danger'>
                        System will re-attempt to decommission the replaced meter soon. But if it fails for too many times, we need a CDO to manually trigger it here.
                    </div>}
                </div>
            </div>}


            <div class="modal" id="re-attempt-message-modal"  data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Request completed</h5>
                        </div>
                        <div class="modal-body">
                            <div className='text-primary'>{this.state.successfulText}</div>
                            <div className='text-danger'>{this.state.failedText}</div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closeModel}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}